import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { fetchAuthSession } from "@aws-amplify/auth"; // ✅ Correct import

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // Use `null` for loading state

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = await fetchAuthSession(); // ✅ Check if user is authenticated
        setIsAuthenticated(!!session.tokens); // ✅ If tokens exist, user is authenticated
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) return <div>Loading...</div>; // ✅ Show loading state
  if (!isAuthenticated) return <Navigate to="/login" />; // ✅ Redirect if not logged in

  return children;
};

export default ProtectedRoute;
